export const getPackageLevelSeverityCounts = (
  pkg: any,
): { criticalCount: number; highCount: number } => {
  const criticalVulnerabilities = new Set();
  const highVulnerabilities = new Set();
  pkg.groups.forEach((_vulnerabilities: any) => {
    if (_vulnerabilities.data[0].severity === 'CRITICAL') {
      criticalVulnerabilities.add(_vulnerabilities.data[0].id);
    }
    if (_vulnerabilities.data[0].severity === 'HIGH') {
      highVulnerabilities.add(_vulnerabilities.data[0].id);
    }
  });
  return {
    criticalCount: criticalVulnerabilities.size,
    highCount: highVulnerabilities.size,
  };
};
